import styled from 'styled-components';

interface PietroskiButtonProps {
    darkMode?: string
    width?: string;
    minHeight?: string;
    margin?: string;
    padding?: string;
    border?: string;
    borderRadius?: string;
    backgroundColor?: string;
    boxShadow?: string;
    fontSize?: string;
}

export const PietroskiButton: any = styled.button`
    margin: ${(props: PietroskiButtonProps) => props.margin ? props.margin : "40px"};
    width: ${(props: PietroskiButtonProps) => props.width ? props.width : "100px"};
    min-height: ${(props: PietroskiButtonProps) => props.minHeight ? props.minHeight : "40px"};
    background-color: ${(props: PietroskiButtonProps) => props.backgroundColor ? props.backgroundColor : "#3da5ff"};
    border: ${(props: PietroskiButtonProps) => props.border ? props.border : "2px solid #3da5ff"};
    border-radius: ${(props: PietroskiButtonProps) => props.borderRadius ? props.borderRadius : "5px"};
    box-shadow: ${(props: PietroskiButtonProps) => props.boxShadow ? props.boxShadow : "0"};
    color: ${(props: PietroskiButtonProps) => props.darkMode ? "#282828" : "black"};
    font-size: ${(props: PietroskiButtonProps) => props.fontSize ? props.fontSize : "1.25rem"};

    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    text-align: center;
`;